// ADE Terms of Service — 5 languages (it, en, es, fr, de)
// Structure: { title, version, sections: [{ h, p?, ul?, p2? }], footer } — **bold** and [label](url) supported

export const TERMS_CONTENT = {
  it: {
    title: "Termini e Condizioni",
    version: "Ultimo aggiornamento: Agosto 2026",
    footer: "Versione documento: 1.0 — A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ)",
    sections: [
      { h: "1. Accettazione dei Termini", p: [
        "Utilizzando l'applicazione ADE (\"l'App\"), accetti di essere vincolato da questi Termini di Servizio (\"Termini\"). Se non accetti questi termini, non utilizzare l'App. L'App è destinata a utenti di almeno 16 anni di età.",
      ]},
      { h: "2. Descrizione del Servizio", p: [
        "ADE è un'applicazione di social networking basata sulla prossimità che permette agli utenti di:",
      ], ul: [
        "Scoprire persone nelle vicinanze tramite GPS",
        "Creare collegamenti e inviare messaggi",
        "Condividere foto e storie",
        "Esplorare ADE Island, un mondo virtuale con isole personalizzabili",
        "Inviare e ricevere regali virtuali tramite crediti interni (ADE Coins)",
      ]},
      { h: "3. Account Utente", ul: [
        "Devi fornire informazioni accurate durante la registrazione",
        "Sei responsabile della sicurezza del tuo account",
        "Non puoi creare account multipli",
        "Puoi eliminare il tuo account in qualsiasi momento dalle Impostazioni",
      ]},
      { h: "4. Contenuti degli Utenti", ul: [
        "Sei responsabile dei contenuti che pubblichi",
        "Non pubblicare contenuti illegali, offensivi, violenti o sessualmente espliciti",
        "Non fare spam, phishing o truffe",
        "Non impersonare altre persone",
        "Ci riserviamo il diritto di rimuovere contenuti che violano questi termini",
      ]},
      { h: "5. ADE Coins, Gift e Transazioni", p: [
        "Gli ADE Coins sono **crediti virtuali interni della piattaforma**, utilizzabili esclusivamente all'interno dell'ecosistema ADE per l'invio di Gift e l'acquisto di contenuti o servizi digitali interni.",
      ], ul: [
        "Gli ADE Coins **non** costituiscono criptovaluta, moneta elettronica, valuta bancaria o strumento finanziario di alcun tipo",
        "Gli ADE Coins **non sono trasferibili ad altri utenti**, non sono convertibili o riscattabili in denaro, non producono interessi e non sono negoziabili su mercati esterni",
        "Quando invii un Gift, i relativi ADE Coins vengono **consumati definitivamente**: il destinatario riceve esclusivamente il Gift (registrazione, animazione e statistiche) e **non riceve alcun ADE Coin** né alcuna somma di denaro",
        "Il costo in Coins di un Gift indica solo la quantità necessaria per inviarlo e **non rappresenta un valore economico attribuito al destinatario**",
        "Gli acquisti di ADE Coins non sono rimborsabili, salvo quanto previsto dalla legge; i Gift inviati non possono essere revocati",
        "I pagamenti sono elaborati in modo sicuro tramite Stripe (web) e Apple (in-app iOS)",
        "Eventuali compensi per i Creator sono disciplinati esclusivamente dai [Termini del Programma ADE Creator Rewards](/creator-terms) e non derivano da alcuna conversione dei Coins",
      ]},
      { h: "6. Proprietà Intellettuale", p: [
        "Tutti i diritti sull'App, inclusi design, marchi, codice e contenuti originali, sono di proprietà di ADE. Gli utenti mantengono i diritti sui propri contenuti ma concedono ad ADE una licenza non esclusiva per visualizzarli nell'App.",
      ]},
      { h: "7. Limitazione di Responsabilità", p: ["ADE non è responsabile per:"], ul: [
        "Comportamenti degli altri utenti",
        "Perdita di dati dovuta a cause di forza maggiore",
        "Interruzioni temporanee del servizio",
        "Contenuti pubblicati dagli utenti",
      ]},
      { h: "8. Sospensione e Terminazione", p: ["Possiamo sospendere o terminare il tuo account se:"], ul: [
        "Violi questi Termini",
        "Il tuo comportamento è segnalato da altri utenti",
        "Utilizzi l'App per attività illegali",
      ]},
      { h: "9. Modifiche ai Termini", p: [
        "Ci riserviamo il diritto di modificare questi Termini. Le modifiche significative saranno comunicate tramite notifica nell'App. L'uso continuato dell'App dopo le modifiche costituisce accettazione dei nuovi Termini.",
      ]},
      { h: "10. Legge Applicabile", p: [
        "Questi Termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente il Foro del luogo di residenza del consumatore (D.Lgs. 206/2005 — Codice del Consumo).",
      ]},
      { h: "11. Contatti", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Sede Legale: Via Marie Curie 17, 39100 Bolzano (BZ) — Italia",
        "P.IVA / C.F.: 03062850999 | REA: GE — 531489",
        "PEC: [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "Per questioni privacy: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "12. ADE Coins — Termini Specifici", p: [
        "Gli ADE Coins sono **crediti interni della piattaforma** destinati esclusivamente all'uso all'interno dell'ecosistema ADE. Non costituiscono moneta legale, moneta elettronica, criptovaluta, valuta bancaria, titoli, prodotti di investimento o strumenti finanziari di alcun tipo, e non rappresentano quote di proprietà in ADE o A.d.E - Around. Discover. Engage.",
      ], ul: [
        "Non convertibili in denaro reale né in alcuna valuta",
        "Non prelevabili né trasferibili a wallet esterni",
        "Non producono interessi né rendimento",
        "Non configurano depositi bancari o conti correnti",
        "I regali (Gift) inviati non possono essere revocati",
        "In caso di chiusura account, i crediti residui non saranno rimborsati",
        "Gli acquisti non sono rimborsabili, salvo quanto previsto dalla legge applicabile",
      ]},
    ],
  },

  en: {
    title: "Terms and Conditions",
    version: "Last updated: August 2026",
    footer: "Document version: 1.0 — A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ), Italy",
    sections: [
      { h: "1. Acceptance of Terms", p: [
        "By using the ADE application (\"the App\"), you agree to be bound by these Terms of Service (\"Terms\"). If you do not agree with these terms, do not use the App. The App is intended for users at least 16 years of age.",
      ]},
      { h: "2. Service Description", p: [
        "ADE is a proximity-based social networking application that lets users:",
      ], ul: [
        "Discover people nearby via GPS",
        "Create connections and send messages",
        "Share photos and stories",
        "Explore ADE Island, a virtual world with customisable islands",
        "Send and receive virtual gifts using internal credits (ADE Coins)",
      ]},
      { h: "3. User Account", ul: [
        "You must provide accurate information at registration",
        "You are responsible for the security of your account",
        "You may not create multiple accounts",
        "You can delete your account at any time from Settings",
      ]},
      { h: "4. User Content", ul: [
        "You are responsible for the content you post",
        "Do not post illegal, offensive, violent or sexually explicit content",
        "Do not engage in spam, phishing or scams",
        "Do not impersonate other people",
        "We reserve the right to remove content that breaches these terms",
      ]},
      { h: "5. ADE Coins, Gifts and Transactions", p: [
        "ADE Coins are **internal virtual credits of the platform**, usable exclusively within the ADE ecosystem to send Gifts and purchase internal digital content or services.",
      ], ul: [
        "ADE Coins **do not** constitute cryptocurrency, electronic money, bank currency or any kind of financial instrument",
        "ADE Coins **are not transferable to other users**, are not convertible or redeemable for money, do not bear interest and are not tradable on external markets",
        "When you send a Gift, the corresponding ADE Coins are **permanently consumed**: the recipient receives only the Gift (record, animation and statistics) and **receives no ADE Coins** nor any sum of money",
        "The Coin cost of a Gift indicates only the amount required to send it and **does not represent any economic value attributed to the recipient**",
        "ADE Coin purchases are non-refundable, save as required by law; sent Gifts cannot be revoked",
        "Payments are processed securely via Stripe (web) and Apple (in-app iOS)",
        "Any compensation for Creators is governed exclusively by the [ADE Creator Rewards Program Terms](/creator-terms) and does not derive from any conversion of Coins",
      ]},
      { h: "6. Intellectual Property", p: [
        "All rights in the App, including design, trademarks, code and original content, belong to ADE. Users retain rights to their content but grant ADE a non-exclusive licence to display it in the App.",
      ]},
      { h: "7. Limitation of Liability", p: ["ADE is not liable for:"], ul: [
        "The behaviour of other users",
        "Data loss due to force majeure",
        "Temporary service interruptions",
        "Content published by users",
      ]},
      { h: "8. Suspension and Termination", p: ["We may suspend or terminate your account if:"], ul: [
        "You breach these Terms",
        "Your behaviour is reported by other users",
        "You use the App for illegal activities",
      ]},
      { h: "9. Changes to the Terms", p: [
        "We reserve the right to change these Terms. Material changes will be communicated via in-App notification. Continued use of the App after the changes constitutes acceptance of the new Terms.",
      ]},
      { h: "10. Governing Law", p: [
        "These Terms are governed by Italian law. Any dispute is subject to the forum of the consumer's place of residence (D.Lgs. 206/2005 — Italian Consumer Code).",
      ]},
      { h: "11. Contact", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Registered Office: Via Marie Curie 17, 39100 Bolzano (BZ) — Italy",
        "VAT/Tax code: 03062850999 | REA: GE — 531489",
        "Certified email (PEC): [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "For privacy matters: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "12. ADE Coins — Specific Terms", p: [
        "ADE Coins are **internal credits of the platform** intended exclusively for use within the ADE ecosystem. They do not constitute legal tender, electronic money, cryptocurrency, bank currency, securities, investment products or financial instruments of any kind, and do not represent ownership interests in ADE or A.d.E - Around. Discover. Engage.",
      ], ul: [
        "Not convertible into real money or any currency",
        "Not withdrawable or transferable to external wallets",
        "Do not bear interest or yield",
        "Do not constitute bank deposits or current accounts",
        "Sent Gifts cannot be revoked",
        "Upon account closure, any remaining credits will not be refunded",
        "Purchases are non-refundable, save as required by applicable law",
      ]},
    ],
  },

  es: {
    title: "Términos y Condiciones",
    version: "Última actualización: Agosto 2026",
    footer: "Versión del documento: 1.0 — A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ), Italia",
    sections: [
      { h: "1. Aceptación de los Términos", p: [
        "Al utilizar la aplicación ADE (\"la App\"), aceptas quedar vinculado por estos Términos de Servicio (\"Términos\"). Si no aceptas estos términos, no utilices la App. La App está destinada a usuarios de al menos 16 años.",
      ]},
      { h: "2. Descripción del Servicio", p: [
        "ADE es una aplicación de redes sociales basada en la proximidad que permite a los usuarios:",
      ], ul: [
        "Descubrir personas cercanas mediante GPS",
        "Crear conexiones y enviar mensajes",
        "Compartir fotos e historias",
        "Explorar ADE Island, un mundo virtual con islas personalizables",
        "Enviar y recibir regalos virtuales mediante créditos internos (ADE Coins)",
      ]},
      { h: "3. Cuenta de Usuario", ul: [
        "Debes proporcionar información precisa al registrarte",
        "Eres responsable de la seguridad de tu cuenta",
        "No puedes crear cuentas múltiples",
        "Puedes eliminar tu cuenta en cualquier momento desde Ajustes",
      ]},
      { h: "4. Contenidos de los Usuarios", ul: [
        "Eres responsable de los contenidos que publicas",
        "No publiques contenidos ilegales, ofensivos, violentos o sexualmente explícitos",
        "No realices spam, phishing ni estafas",
        "No suplantes a otras personas",
        "Nos reservamos el derecho de retirar contenidos que infrinjan estos términos",
      ]},
      { h: "5. ADE Coins, Gift y Transacciones", p: [
        "Los ADE Coins son **créditos virtuales internos de la plataforma**, utilizables exclusivamente dentro del ecosistema ADE para enviar Gifts y comprar contenidos o servicios digitales internos.",
      ], ul: [
        "Los ADE Coins **no** constituyen criptomoneda, dinero electrónico, moneda bancaria ni instrumento financiero de ningún tipo",
        "Los ADE Coins **no son transferibles a otros usuarios**, no son convertibles ni canjeables por dinero, no generan intereses y no son negociables en mercados externos",
        "Cuando envías un Gift, los ADE Coins correspondientes se **consumen definitivamente**: el destinatario recibe únicamente el Gift (registro, animación y estadísticas) y **no recibe ningún ADE Coin** ni cantidad de dinero",
        "El coste en Coins de un Gift indica solo la cantidad necesaria para enviarlo y **no representa ningún valor económico atribuido al destinatario**",
        "Las compras de ADE Coins no son reembolsables, salvo lo previsto por la ley; los Gifts enviados no pueden revocarse",
        "Los pagos se procesan de forma segura mediante Stripe (web) y Apple (in-app iOS)",
        "Cualquier compensación para los Creators se rige exclusivamente por los [Términos del Programa ADE Creator Rewards](/creator-terms) y no deriva de conversión alguna de los Coins",
      ]},
      { h: "6. Propiedad Intelectual", p: [
        "Todos los derechos sobre la App, incluidos diseño, marcas, código y contenidos originales, son propiedad de ADE. Los usuarios conservan los derechos sobre sus contenidos pero conceden a ADE una licencia no exclusiva para mostrarlos en la App.",
      ]},
      { h: "7. Limitación de Responsabilidad", p: ["ADE no es responsable de:"], ul: [
        "El comportamiento de otros usuarios",
        "Pérdida de datos por causas de fuerza mayor",
        "Interrupciones temporales del servicio",
        "Contenidos publicados por los usuarios",
      ]},
      { h: "8. Suspensión y Terminación", p: ["Podemos suspender o cerrar tu cuenta si:"], ul: [
        "Infringes estos Términos",
        "Otros usuarios denuncian tu comportamiento",
        "Utilizas la App para actividades ilegales",
      ]},
      { h: "9. Modificaciones de los Términos", p: [
        "Nos reservamos el derecho de modificar estos Términos. Los cambios significativos se comunicarán mediante notificación en la App. El uso continuado de la App tras las modificaciones constituye aceptación de los nuevos Términos.",
      ]},
      { h: "10. Ley Aplicable", p: [
        "Estos Términos se rigen por la ley italiana. Para cualquier controversia será competente el foro del lugar de residencia del consumidor (D.Lgs. 206/2005 — Código del Consumo italiano).",
      ]},
      { h: "11. Contactos", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Domicilio social: Via Marie Curie 17, 39100 Bolzano (BZ) — Italia",
        "CIF/NIF: 03062850999 | REA: GE — 531489",
        "PEC: [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "Para cuestiones de privacidad: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "12. ADE Coins — Términos Específicos", p: [
        "Los ADE Coins son **créditos internos de la plataforma** destinados exclusivamente al uso dentro del ecosistema ADE. No constituyen moneda de curso legal, dinero electrónico, criptomoneda, moneda bancaria, valores, productos de inversión ni instrumentos financieros de ningún tipo, y no representan cuotas de propiedad en ADE o A.d.E - Around. Discover. Engage.",
      ], ul: [
        "No convertibles en dinero real ni en ninguna divisa",
        "No retirables ni transferibles a wallets externos",
        "No generan intereses ni rendimiento",
        "No constituyen depósitos bancarios ni cuentas corrientes",
        "Los regalos (Gift) enviados no pueden revocarse",
        "En caso de cierre de la cuenta, los créditos residuales no serán reembolsados",
        "Las compras no son reembolsables, salvo lo previsto por la ley aplicable",
      ]},
    ],
  },

  fr: {
    title: "Conditions Générales",
    version: "Dernière mise à jour : Août 2026",
    footer: "Version du document : 1.0 — A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ), Italie",
    sections: [
      { h: "1. Acceptation des Conditions", p: [
        "En utilisant l'application ADE (« l'App »), vous acceptez d'être lié par ces Conditions d'Utilisation (« Conditions »). Si vous n'acceptez pas ces conditions, n'utilisez pas l'App. L'App est destinée aux utilisateurs âgés d'au moins 16 ans.",
      ]},
      { h: "2. Description du Service", p: [
        "ADE est une application de réseau social basée sur la proximité qui permet aux utilisateurs de :",
      ], ul: [
        "Découvrir des personnes à proximité via GPS",
        "Créer des connexions et envoyer des messages",
        "Partager des photos et des stories",
        "Explorer ADE Island, un monde virtuel avec des îles personnalisables",
        "Envoyer et recevoir des cadeaux virtuels via des crédits internes (ADE Coins)",
      ]},
      { h: "3. Compte Utilisateur", ul: [
        "Vous devez fournir des informations exactes lors de l'inscription",
        "Vous êtes responsable de la sécurité de votre compte",
        "Vous ne pouvez pas créer plusieurs comptes",
        "Vous pouvez supprimer votre compte à tout moment depuis les Paramètres",
      ]},
      { h: "4. Contenus des Utilisateurs", ul: [
        "Vous êtes responsable des contenus que vous publiez",
        "Ne publiez pas de contenus illégaux, offensants, violents ou sexuellement explicites",
        "Ne pratiquez pas de spam, de phishing ou d'arnaques",
        "Ne vous faites pas passer pour d'autres personnes",
        "Nous nous réservons le droit de supprimer les contenus contrevenant aux présentes conditions",
      ]},
      { h: "5. ADE Coins, Gifts et Transactions", p: [
        "Les ADE Coins sont des **crédits virtuels internes de la plateforme**, utilisables exclusivement au sein de l'écosystème ADE pour envoyer des Gifts et acheter des contenus ou services numériques internes.",
      ], ul: [
        "Les ADE Coins **ne** constituent **pas** une cryptomonnaie, de la monnaie électronique, une monnaie bancaire ou un instrument financier de quelque nature que ce soit",
        "Les ADE Coins **ne sont pas transférables à d'autres utilisateurs**, ne sont pas convertibles ni remboursables en argent, ne produisent pas d'intérêts et ne sont pas négociables sur des marchés externes",
        "Lorsque vous envoyez un Gift, les ADE Coins correspondants sont **définitivement consommés** : le destinataire reçoit uniquement le Gift (enregistrement, animation et statistiques) et **ne reçoit aucun ADE Coin** ni aucune somme d'argent",
        "Le coût en Coins d'un Gift indique uniquement la quantité nécessaire à son envoi et **ne représente aucune valeur économique attribuée au destinataire**",
        "Les achats d'ADE Coins ne sont pas remboursables, sauf disposition légale contraire ; les Gifts envoyés ne peuvent être révoqués",
        "Les paiements sont traités de manière sécurisée via Stripe (web) et Apple (in-app iOS)",
        "Toute rémunération éventuelle des Creators est régie exclusivement par les [Conditions du Programme ADE Creator Rewards](/creator-terms) et ne résulte d'aucune conversion des Coins",
      ]},
      { h: "6. Propriété Intellectuelle", p: [
        "Tous les droits sur l'App, y compris le design, les marques, le code et les contenus originaux, appartiennent à ADE. Les utilisateurs conservent les droits sur leurs contenus mais accordent à ADE une licence non exclusive pour les afficher dans l'App.",
      ]},
      { h: "7. Limitation de Responsabilité", p: ["ADE n'est pas responsable de :"], ul: [
        "Le comportement des autres utilisateurs",
        "La perte de données due à un cas de force majeure",
        "Les interruptions temporaires du service",
        "Les contenus publiés par les utilisateurs",
      ]},
      { h: "8. Suspension et Résiliation", p: ["Nous pouvons suspendre ou résilier votre compte si :"], ul: [
        "Vous enfreignez ces Conditions",
        "Votre comportement est signalé par d'autres utilisateurs",
        "Vous utilisez l'App pour des activités illégales",
      ]},
      { h: "9. Modifications des Conditions", p: [
        "Nous nous réservons le droit de modifier ces Conditions. Les modifications importantes seront communiquées par notification dans l'App. La poursuite de l'utilisation de l'App après les modifications vaut acceptation des nouvelles Conditions.",
      ]},
      { h: "10. Droit Applicable", p: [
        "Ces Conditions sont régies par le droit italien. Pour tout litige, le tribunal du lieu de résidence du consommateur est compétent (D.Lgs. 206/2005 — Code de la Consommation italien).",
      ]},
      { h: "11. Contacts", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Siège social : Via Marie Curie 17, 39100 Bolzano (BZ) — Italie",
        "TVA/Code fiscal : 03062850999 | REA : GE — 531489",
        "PEC : [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "Pour les questions de confidentialité : [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "12. ADE Coins — Conditions Spécifiques", p: [
        "Les ADE Coins sont des **crédits internes de la plateforme** destinés exclusivement à un usage au sein de l'écosystème ADE. Ils ne constituent pas de la monnaie légale, de la monnaie électronique, une cryptomonnaie, une monnaie bancaire, des titres, des produits d'investissement ou des instruments financiers de quelque nature que ce soit, et ne représentent pas de parts de propriété dans ADE ou A.d.E - Around. Discover. Engage.",
      ], ul: [
        "Non convertibles en argent réel ni en aucune devise",
        "Non retirables ni transférables vers des wallets externes",
        "Ne produisent ni intérêts ni rendement",
        "Ne constituent ni dépôts bancaires ni comptes courants",
        "Les cadeaux (Gift) envoyés ne peuvent être révoqués",
        "En cas de fermeture du compte, les crédits résiduels ne seront pas remboursés",
        "Les achats ne sont pas remboursables, sauf disposition de la loi applicable",
      ]},
    ],
  },

  de: {
    title: "Allgemeine Nutzungsbedingungen",
    version: "Letzte Aktualisierung: August 2026",
    footer: "Dokumentversion: 1.0 — A.d.E - Around. Discover. Engage, Via Marie Curie 17, 39100 Bolzano (BZ), Italien",
    sections: [
      { h: "1. Annahme der Bedingungen", p: [
        "Durch die Nutzung der ADE-Anwendung („die App“) erklären Sie sich mit diesen Nutzungsbedingungen („Bedingungen“) einverstanden. Wenn Sie diesen Bedingungen nicht zustimmen, nutzen Sie die App nicht. Die App richtet sich an Nutzer ab 16 Jahren.",
      ]},
      { h: "2. Beschreibung des Dienstes", p: [
        "ADE ist eine standortbasierte Social-Networking-Anwendung, die es Nutzern ermöglicht:",
      ], ul: [
        "Personen in der Nähe per GPS zu entdecken",
        "Verbindungen aufzubauen und Nachrichten zu senden",
        "Fotos und Stories zu teilen",
        "ADE Island zu erkunden, eine virtuelle Welt mit individualisierbaren Inseln",
        "Virtuelle Geschenke mittels interner Guthaben (ADE Coins) zu senden und zu empfangen",
      ]},
      { h: "3. Nutzerkonto", ul: [
        "Sie müssen bei der Registrierung wahrheitsgemäße Angaben machen",
        "Sie sind für die Sicherheit Ihres Kontos verantwortlich",
        "Sie dürfen keine mehreren Konten anlegen",
        "Sie können Ihr Konto jederzeit in den Einstellungen löschen",
      ]},
      { h: "4. Nutzerinhalte", ul: [
        "Sie sind für die Inhalte verantwortlich, die Sie veröffentlichen",
        "Veröffentlichen Sie keine rechtswidrigen, beleidigenden, gewalttätigen oder sexuell expliziten Inhalte",
        "Betreiben Sie keinen Spam, kein Phishing und keine Betrügereien",
        "Geben Sie sich nicht als andere Personen aus",
        "Wir behalten uns das Recht vor, Inhalte zu entfernen, die gegen diese Bedingungen verstoßen",
      ]},
      { h: "5. ADE Coins, Gifts und Transaktionen", p: [
        "ADE Coins sind **interne virtuelle Guthaben der Plattform**, die ausschließlich innerhalb des ADE-Ökosystems zum Senden von Gifts und zum Erwerb interner digitaler Inhalte oder Dienste verwendet werden können.",
      ], ul: [
        "ADE Coins stellen **keine** Kryptowährung, kein E-Geld, keine Bankwährung und kein Finanzinstrument jeglicher Art dar",
        "ADE Coins **sind nicht auf andere Nutzer übertragbar**, nicht in Geld umtauschbar oder einlösbar, verzinsen sich nicht und sind nicht an externen Märkten handelbar",
        "Beim Senden eines Gifts werden die entsprechenden ADE Coins **endgültig verbraucht**: Der Empfänger erhält ausschließlich das Gift (Eintrag, Animation und Statistiken) und **erhält keine ADE Coins** und keinerlei Geldbetrag",
        "Die Coin-Kosten eines Gifts geben nur die zum Senden erforderliche Menge an und **stellen keinen dem Empfänger zugerechneten wirtschaftlichen Wert dar**",
        "Käufe von ADE Coins sind, vorbehaltlich zwingender gesetzlicher Vorschriften, nicht erstattungsfähig; gesendete Gifts können nicht widerrufen werden",
        "Zahlungen werden sicher über Stripe (Web) und Apple (In-App iOS) abgewickelt",
        "Etwaige Vergütungen für Creators werden ausschließlich durch die [Bedingungen des ADE Creator Rewards Programms](/creator-terms) geregelt und ergeben sich nicht aus einer Umrechnung der Coins",
      ]},
      { h: "6. Geistiges Eigentum", p: [
        "Alle Rechte an der App, einschließlich Design, Marken, Code und Originalinhalten, stehen ADE zu. Die Nutzer behalten die Rechte an ihren Inhalten, gewähren ADE jedoch eine nicht-ausschließliche Lizenz zu deren Anzeige in der App.",
      ]},
      { h: "7. Haftungsbeschränkung", p: ["ADE haftet nicht für:"], ul: [
        "Das Verhalten anderer Nutzer",
        "Datenverluste aufgrund höherer Gewalt",
        "Vorübergehende Serviceunterbrechungen",
        "Von Nutzern veröffentlichte Inhalte",
      ]},
      { h: "8. Sperrung und Kündigung", p: ["Wir können Ihr Konto sperren oder kündigen, wenn:"], ul: [
        "Sie gegen diese Bedingungen verstoßen",
        "Ihr Verhalten von anderen Nutzern gemeldet wird",
        "Sie die App für rechtswidrige Aktivitäten nutzen",
      ]},
      { h: "9. Änderungen der Bedingungen", p: [
        "Wir behalten uns das Recht vor, diese Bedingungen zu ändern. Wesentliche Änderungen werden per In-App-Benachrichtigung mitgeteilt. Die fortgesetzte Nutzung der App nach den Änderungen gilt als Annahme der neuen Bedingungen.",
      ]},
      { h: "10. Anwendbares Recht", p: [
        "Diese Bedingungen unterliegen italienischem Recht. Für Streitigkeiten ist der Gerichtsstand des Wohnsitzes des Verbrauchers zuständig (D.Lgs. 206/2005 — Italienisches Verbrauchergesetzbuch).",
      ]},
      { h: "11. Kontakt", p: [
        "**A.d.E - Around. Discover. Engage**",
        "Sitz: Via Marie Curie 17, 39100 Bolzano (BZ) — Italien",
        "USt-IdNr./Steuer-Nr.: 03062850999 | REA: GE — 531489",
        "PEC: [arabellgroupsrls@legalmail.it](mailto:arabellgroupsrls@legalmail.it)",
        "Für Datenschutzanfragen: [privacy@ade-app.com](mailto:privacy@ade-app.com)",
      ]},
      { h: "12. ADE Coins — Spezielle Bedingungen", p: [
        "ADE Coins sind **interne Guthaben der Plattform**, die ausschließlich für die Nutzung innerhalb des ADE-Ökosystems bestimmt sind. Sie stellen kein gesetzliches Zahlungsmittel, kein E-Geld, keine Kryptowährung, keine Bankwährung, keine Wertpapiere, keine Anlageprodukte und keine Finanzinstrumente jeglicher Art dar und verkörpern keine Eigentumsanteile an ADE oder A.d.E - Around. Discover. Engage.",
      ], ul: [
        "Nicht in echtes Geld oder eine sonstige Währung umtauschbar",
        "Nicht abhebbar oder auf externe Wallets übertragbar",
        "Verzinsen sich nicht und erzielen keine Rendite",
        "Stellen weder Bankeinlagen noch Girokonten dar",
        "Gesendete Gifts können nicht widerrufen werden",
        "Bei Kontoschließung werden Restguthaben nicht erstattet",
        "Käufe sind, vorbehaltlich zwingender Rechtsvorschriften, nicht erstattungsfähig",
      ]},
    ],
  },
};
